import VideoPlayerContainer from './VideoPlayerContainer'

export default VideoPlayerContainer
// eslint-disable-next-line import/export
export * from './VideoPlayerContainer'
